export default __webpack_public_path__ + "static/media/logo-labss.7f691b2a.png";